exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".body[data-v-f6d18cce]{height:95%!important}.body .cln-debut[data-v-f6d18cce],.body .cln-envoi[data-v-f6d18cce],.body .cln-etat[data-v-f6d18cce],.body .cln-fin[data-v-f6d18cce],.body .cln-nbr[data-v-f6d18cce],.body .cln-periode[data-v-f6d18cce]{width:13.5%}.body .cln-action[data-v-f6d18cce]{width:19%}.body .tbody .line[data-v-f6d18cce]{background-image:url(" + require("../../../assets/bg_tableau.png") + ")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-f6d18cce","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/Primobox/envoiBulletins/envoiBulletins.scss
// module id = v50D
// module chunks = 2